exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".svgIconComponent---18owd{display:block;pointer-events:none;width:12px}", ""]);

// exports
exports.locals = {
	"svgIconComponent": "svgIconComponent---18owd"
};